module.exports = __webpack_public_path__ + "img/庆云签约大图.d86e8695.jpg";